import { writable } from 'svelte/store'
import type { Writable } from 'svelte/store'

export const hasCheckedDriverSalaryFiles: Writable<boolean> = writable(false)

export const isDriverSalaryMenuVisible: Writable<boolean> = writable(false)
